<div class="demographic-section" *ngIf="!isLoadingAnimation; else loadingContent">
  <div>
    <div class="user-name">
      <h3 class="tootltip-wrapper" tooltipDirective [data]="userName" [maxCharLength]="25">
        {{ userName | truncate : 25 }}
      </h3>
      <ods-button
        *ngIf="isEditOn || isAddUserEditOn"
        id="editBtn"
        role="link"
        tabindex="0"
        [attr.aria-label]="
          'Edit ' + assignUserRoleInfo?.userPreferences?.firstName + ' ' + assignUserRoleInfo?.userPreferences?.lastName
        "
        variant="anchor"
        (click)="navigateTo()"
      >
        Edit
        <ods-icon slot="icon" variant="edit"></ods-icon>
      </ods-button>
    </div>
    <div class="user-detailInfo">
      <div class="detailInfo-box">
        <h5>Email</h5>
        <p
          class="tootltip-wrapper"
          tooltipDirective
          [data]="assignUserRoleInfo?.userPreferences?.email"
          [maxCharLength]="25"
        >
          {{ assignUserRoleInfo?.userPreferences?.email | truncate : 25 }}
        </p>
      </div>
      <div class="detailInfo-box">
        <h5>Office Address</h5>
        <div class="box-address">
          <p
            class="tootltip-wrapper no-margin"
            tooltipDirective
            [data]="assignUserRoleInfo?.userPreferences?.address1"
            [maxCharLength]="25"
          >
            {{ assignUserRoleInfo?.userPreferences?.address1 | truncate : 25 }},
          </p>
          <p
            *ngIf="assignUserRoleInfo?.userPreferences?.address2"
            class="tootltip-wrapper no-margin"
            tooltipDirective
            [data]="assignUserRoleInfo?.userPreferences?.address2"
            [maxCharLength]="25"
          >
            &nbsp;{{ assignUserRoleInfo?.userPreferences?.address2 | truncate : 25 }}
          </p>
          <p class="no-margin">
            <span
              class="tootltip-wrapper"
              tooltipDirective
              [data]="assignUserRoleInfo?.userPreferences?.city"
              [maxCharLength]="25"
              >{{ assignUserRoleInfo?.userPreferences?.city | truncate : 25 }},&nbsp;</span
            >{{ assignUserRoleInfo?.userPreferences?.state }} {{ assignUserRoleInfo?.userPreferences?.zip | zipCode }}
          </p>
        </div>
      </div>
      <div class="detailInfo-box">
        <h5>Work Phone</h5>
        <p>{{ ((assignUserRoleInfo?.userPreferences?.workPhone ? assignUserRoleInfo?.userPreferences?.workPhone : assignUserRoleInfo?.userPreferences?.phoneNumber) | phoneNumber) || 'Not Available' }}</p>
        <h5 *ngIf="assignUserRoleInfo?.userPreferences?.phoneNumberExtension">Ext</h5>
        <p>
          {{
            assignUserRoleInfo?.userPreferences?.phoneNumberExtension ||
              assignUserRoleInfo?.userPreferences?.workPhoneExtension
          }}
        </p>
      </div>
    </div>
  </div>
  <!-- empty check for temporary solution -->
  <div
    *ngIf="((isEditOn && this.screenType !== 'multi-sets') || securitySets?.length === 1 || securitySets?.length === '') && !isFromPendinguser"
  >
    <ods-button id="removeBtn" variant="tertiary" (click)="removeEditUserPopUp()">Remove</ods-button>
  </div>
</div>
<div *ngIf="groupIdLength > 1; else deactivateUser">
  <app-modal
    *ngIf="openEditUserPopup"
    [showModal]="openEditUserPopup"
    [componentData]="removeUserModalData"
    (closeModal)="closePopUp()"
    (btnCallback1)="removeEditUser()"
    (btnCallback2)="closePopUp()"
  >
    <div customModalBody class="popUp-body" aria-labelledby="removeOaaBody">
      <p id="removeOaaBody">
        Are you sure you want to remove
        <strong
          >{{ assignUserRoleInfo?.userPreferences?.firstName }}
          {{ assignUserRoleInfo?.userPreferences?.lastName }}</strong
        >
        from the selected security set(s)?
      </p>
    </div>
  </app-modal>
</div>
<ng-template #deactivateUser>
  <app-modal
    *ngIf="openEditUserPopup"
    [showModal]="openEditUserPopup"
    [componentData]="deactivateUserModalData"
    (closeModal)="closePopUp()"
    (btnCallback1)="removeEditUser()"
    (btnCallback2)="closePopUp()"
  >
    <div customModalBody class="popUp-body" aria-labelledby="removeOaaBody">
      <p id="removeOaaBody">
        Removing
        <strong
          >{{ assignUserRoleInfo?.userPreferences?.firstName }}
          {{ assignUserRoleInfo?.userPreferences?.lastName }}</strong
        >
        from their last Security Set will deactivate their account in Provider OnLine. Are you sure you want to remove
        <strong
          >{{ assignUserRoleInfo?.userPreferences?.firstName }}
          {{ assignUserRoleInfo?.userPreferences?.lastName }}</strong
        >
        and deactivate their account?
      </p>
    </div>
  </app-modal>
</ng-template>

<app-modal
  *ngIf="isOaaUser"
  [showModal]="isOaaUser"
  [componentData]="oaaUserModalData"
  (closeModal)="closePopUp()"
  (btnCallback1)="navigateToOaa()"
  (btnCallback2)="closePopUp()"
>
  <div customModalBody class="popUp-body" aria-labelledby="removeOaaBody">
    <p>
      <span class="errorIcon"></span>
      <strong
        >{{ assignUserRoleInfo?.userPreferences?.firstName }}
        {{ assignUserRoleInfo?.userPreferences?.lastName }}</strong
      >
      is currently an Online Account Administrator of the selected security set(s). Before removing the user, first
      update their OAA permissions
    </p>
  </div>
</app-modal>

<ng-template #loadingContent>
  <app-pol-loader  [skeletonType]="'text'" [skeletonRows]="3" [skeletonTitle]="true"
  [skeletonFooter]="true"></app-pol-loader>
</ng-template>
<hr />
